<div class="main-content">
  <app-header
    [title]="'LEGAL_DOCUMENTS_PREVIEW.TITLE' | translate"
    [subtitle]="'LEGAL_DOCUMENTS_PREVIEW.SUBTITLE' | translate"
  />

  <div class="row mt-5">
    <div class="col-12">
      <app-icam-container [iconName]="'repository'" [iconColor]="'white'">
        <div class="preview-container">
          @if (isLoading) {
            <div class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
            </div>
          } @else {
            <div class="mb-4">
              @if (anyUnreachable) {
                <span class="status-badge status-error">{{ 'LEGAL_DOCUMENTS_PREVIEW.STATUS_ERROR' | translate }}</span>
              } @else if (allFromRegistry) {
                <span class="status-badge status-ok">{{ 'LEGAL_DOCUMENTS_PREVIEW.STATUS_ALL_REGISTRY' | translate }}</span>
              } @else {
                <span class="status-badge status-warn">{{ 'LEGAL_DOCUMENTS_PREVIEW.STATUS_SOME_FALLBACK' | translate }}</span>
              }
            </div>

            <h5 class="section-title">{{ 'LEGAL_DOCUMENTS_PREVIEW.WHAT_USERS_GET' | translate }}</h5>
            <p class="hint">{{ 'LEGAL_DOCUMENTS_PREVIEW.WHAT_USERS_GET_HINT' | translate }}</p>

            <div class="table-responsive mb-5">
              <table class="table align-middle preview-table">
                <thead>
                  <tr>
                    <th>{{ 'LEGAL_DOCUMENTS_PREVIEW.COL_DOCUMENT' | translate }}</th>
                    <th>{{ 'LEGAL_DOCUMENTS_PREVIEW.COL_LANG' | translate }}</th>
                    <th>{{ 'LEGAL_DOCUMENTS_PREVIEW.COL_SOURCE' | translate }}</th>
                    <th>{{ 'LEGAL_DOCUMENTS_PREVIEW.COL_FILE' | translate }}</th>
                    <th>{{ 'LEGAL_DOCUMENTS_PREVIEW.COL_TEXT' | translate }}</th>
                    <th>{{ 'LEGAL_DOCUMENTS_PREVIEW.COL_MODIFIED' | translate }}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of rows; track row.type + row.lang) {
                    <tr>
                      <td class="fw-semibold">{{ 'LEGAL_DOCUMENTS.TYPES.' + row.type | translate }}</td>
                      <td>{{ row.lang | uppercase }}</td>
                      <td>
                        @if (row.unreachable) {
                          <span class="status-badge status-error">{{ 'LEGAL_DOCUMENTS_PREVIEW.SOURCE_ERROR' | translate }}</span>
                        } @else if (row.fromRegistry) {
                          <span class="status-badge status-ok">{{ 'LEGAL_DOCUMENTS_PREVIEW.SOURCE_REGISTRY' | translate }}</span>
                        } @else {
                          <span class="status-badge status-warn">{{ 'LEGAL_DOCUMENTS_PREVIEW.SOURCE_STATIC' | translate }}</span>
                        }
                      </td>
                      <td class="small">{{ row.fileName || ('LEGAL_DOCUMENTS_PREVIEW.NO_FILE' | translate) }}</td>
                      <td class="small">
                        @if (row.htmlLength > 0) {
                          {{ row.htmlLength }} {{ 'LEGAL_DOCUMENTS_PREVIEW.CHARS' | translate }}
                        } @else {
                          <span class="hint">—</span>
                        }
                      </td>
                      <td class="small">{{ row.modifiedDate || '—' }}</td>
                      <td class="text-end">
                        <a class="secondary-button compact" [href]="row.fileUrl" target="_blank" rel="noopener noreferrer">
                          {{ 'LEGAL_DOCUMENTS_PREVIEW.OPEN_PDF' | translate }}
                        </a>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <h5 class="section-title">{{ 'LEGAL_DOCUMENTS_PREVIEW.SCREENS' | translate }}</h5>
            <p class="hint">{{ 'LEGAL_DOCUMENTS_PREVIEW.SCREENS_HINT' | translate }}</p>

            <div class="row g-3 mb-4">
              <div class="col-12 col-lg-4">
                <div class="screen-card">
                  <h6>{{ 'LEGAL_DOCUMENTS_PREVIEW.SCREEN_REGISTRATION' | translate }}</h6>
                  <p class="hint">{{ 'LEGAL_DOCUMENTS_PREVIEW.SCREEN_REGISTRATION_HINT' | translate }}</p>
                  <button type="button" class="primary-button" (click)="openRegistrationModal()">
                    {{ 'LEGAL_DOCUMENTS_PREVIEW.OPEN' | translate }}
                  </button>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="screen-card">
                  <h6>{{ 'LEGAL_DOCUMENTS_PREVIEW.SCREEN_ACCEPTANCE' | translate }}</h6>
                  <p class="hint">{{ 'LEGAL_DOCUMENTS_PREVIEW.SCREEN_ACCEPTANCE_HINT' | translate }}</p>
                  <button type="button" class="primary-button" (click)="openAcceptanceModal()">
                    {{ 'LEGAL_DOCUMENTS_PREVIEW.OPEN' | translate }}
                  </button>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="screen-card">
                  <h6>{{ 'LEGAL_DOCUMENTS_PREVIEW.SCREEN_ACCOUNT' | translate }}</h6>
                  <p class="hint">{{ 'LEGAL_DOCUMENTS_PREVIEW.SCREEN_ACCOUNT_HINT' | translate }}</p>
                  <button type="button" class="primary-button" (click)="openAccountModal()">
                    {{ 'LEGAL_DOCUMENTS_PREVIEW.OPEN' | translate }}
                  </button>
                </div>
              </div>
            </div>

            <div class="preview-note">
              <strong>{{ 'LEGAL_DOCUMENTS_PREVIEW.NOTE_TITLE' | translate }}</strong>
              {{ 'LEGAL_DOCUMENTS_PREVIEW.NOTE_BODY' | translate }}
            </div>

            <h5 class="section-title mt-5">{{ 'LEGAL_DOCUMENTS_PREVIEW.LANGUAGE' | translate }}</h5>
            <p class="hint">{{ 'LEGAL_DOCUMENTS_PREVIEW.LANGUAGE_HINT' | translate }}</p>
            <div class="d-flex gap-2">
              @for (lang of languages; track lang) {
                <button
                  type="button"
                  class="lang-button"
                  [class.active]="currentLang === lang"
                  (click)="switchLanguage(lang)"
                >
                  {{ lang | uppercase }}
                </button>
              }
            </div>
          }
        </div>
      </app-icam-container>
    </div>
  </div>

  <div class="mt-4 mb-4">
    <app-back-button [linkText]="'LEGAL_DOCUMENTS_PREVIEW.BACK_TO_LIST'" [routerLink]="['/legal-documents']" />
  </div>
</div>
<app-footer-copyright />
